<template>
  <div class="dt-textfield" :class="{
    'focused': focused,
    [type]: type
  }">
    <input
      :value="value"
      ref="input"
      :type="type"
      class="dt-textfield--input"
      :placeholder="placeholder"
      :name="id"
      :id="id"
      :class="id"
      @keyup="onKeyup"
      @focus="onFocus"
      @blur="onBlur"
    />
    <textarea
      :value="value"
      ref="textarea"
      :type="type"
      class="dt-textfield--textarea"
      :placeholder="placeholder"
      :name="id"
      :id="id"
      :class="id"
      @keyup="onKeyup"
      @focus="onFocus"
      @blur="onBlur"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    type: {},
    placeholder: {
      type: String
    },
    id: {
      type: String
    }
  },
  mounted: function() {
    const rct = this.$refs['input'].getBoundingClientRect();
    // console.log(rct);
    this.$el.style.setProperty('--dttf-textarea-width', `${rct.width + 1}px`);
  },
  data: function() {
    return {
      focused: false
    };
  },
  methods: {
    onKeyup: function(event) {
      this.$emit("input", event.target.value);
    },
    onFocus: function(event) {
      this.focused = true;
    },
    onBlur: function(event) {
      this.focused = false;
      this.emitBlur(event.target.value);
    },
    emitBlur: function(value) {
      this.$emit("blur", value || this.$refs["input"].value);
    }
  }
};
</script>



<style lang="scss" scoped>

@mixin hoverStyle() {
  border: 1px solid var(--text-5);
  outline: none;
  background: var(--sprt-11);

  &::after {
    display: none;
  }
  &::before {
    display: none;
  }


  height: 100px;
  z-index: 99;
  position: absolute;
  width: var(--dttf-textarea-width);

  .dt-textfield--textarea {
    display: inherit;

    height: 100%;
    width: 100%;
    top: 0px;
  }
  .dt-textfield--input {
    display: none;
  }
}

.dt-textfield {
  --dttf-textarea-width: 0%;
  
  $leftPadding: 10px;

  position: relative;
  height: 100%;
  width: 100%;
  border: 1px solid transparent;

  // transition: 500ms ease-out;

  &--input {
    padding-left: $leftPadding;
    resize: none;
    border: transparent;

    height: 100%;
    width: 100%;

    &:focus,
    :active {
      outline: none;
      color: black;
    }

    &[type="number"] {
      text-align: right;
      padding-right: 5px;
    }
  }

  &--textarea {
    padding-left: $leftPadding;
    display: none;
    resize: none;
    width: 0px;
    padding-top: 4px;

    &:focus{
      outline: none;
    }
  }

  &.focused {
    @include hoverStyle();
  }

  &::before {
    content: "";
    position: absolute;

    width: 0;
    height: 0;

    right: -1px;
    bottom: 0px;
    z-index: 10;

    // Create Triangle

    border-top-width: 7px;
    border-top-style: solid;
    border-top-color: transparent;
    border-right-width: 7px;
    border-right-style: solid;
    border-right-color: var(--sprt-86);
  }
  &::after {
    content: "";
    position: absolute;

    width: 15px;
    height: 100%;

    right: 0px;
    bottom: 0px;
    z-index: 9;

    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.479),
      white
    );
  }

  &:hover {
    @include hoverStyle();
    .actionsov{
      visibility: hidden !important;
    }
  }

  &.focused {
    &::before {
      border-right-color: var(--sprt-5);
    }
  }
}
</style>
